import { useMemo, useState } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import useListCmsPaginatedContents from 'hooks/useListCmsPaginatedContents'
import type { CmsContentT } from 'types'
import { CONTENT_TYPES } from 'types/cms'
import type { EventTabProps } from './types'
import { groupEvents } from './utils'

const useEvents = ({ eventTimelineFilter, ownerId }: EventTabProps) => {
  const { locale } = useFavurTranslation()
  const [selectedEvent, setSelectedEvent] = useState<CmsContentT | undefined>()
  const { list, loading, hasMoreElements, loadMore } = useListCmsPaginatedContents({
    contentType: CONTENT_TYPES.event,
    eventTimelineFilter,
    ownerId: ownerId,
  })
  const groupedEvents = useMemo(
    () => groupEvents({ contentList: list, eventTimelineFilter, locale }),
    [eventTimelineFilter, list, locale],
  )

  return { groupedEvents, hasMoreElements, loadMore, loading, selectedEvent, setSelectedEvent }
}

export default useEvents
